angular.module('impactx.basket').controller('ProductChangeListCtrl',  [
    '$scope',
    'dataGen',
    '$context',
    '$redirect',
    '$securityManager',
    'selectedListItems',
    'ListHelperService',
    'ToastService',
    'DownloadService',
    ProductChangeListCtrl]);

function ProductChangeListCtrl($scope, dataGen, $context, $redirect, $securityManager, selectedListItems, ListHelperService, ToastService, DownloadService)
{
    var ctrl = this;

    this.getEditLink = function() {
        return "editproduct/" + selectedListItems.getFirstSelectedId() + "/" + selectedListItems.getFirstSelectedItem().catid + "/true";
    };

    this.getViewLink = function() {
        return "editproductreadonly/" + selectedListItems.getFirstSelectedId() + "/" + selectedListItems.getFirstSelectedItem().catid;
    };

    this.canEdit = function() {
        if(selectedListItems.isSingleSelection()) {
            return selectedListItems.getFirstSelectedItem().PROWork.canEdit;
        }
        return false;
    };

    this.canView = function() {
        return selectedListItems.isSingleSelection()
    };

    this.canEditMultiple = function () {
        if(!selectedListItems.isSingleSelection() && selectedListItems.isMultiSelection()) {
            return !selectedListItems.getSelectedItems().some(function(item) {
                return !item.PROWork.canEdit;
            });
        }
        return false;
    }

    this.openEditPriceRule = function () {
        $redirect.redirectTo(null, "productchangepricerules", selectedListItems.getSelectedIds());
    }

    this.removeOrderStop = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/product/orderstop/remove").then(function (data) {
            ListHelperService.refreshListData($scope, 'productChangeListCtrl', {unselectRows: selectedItems});
            ToastService.openStandardToast(data.trns.saveSuccess);
        })
    };

    this.addOrderStop = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/product/orderstop/add").then(function (data) {
            ListHelperService.refreshListData($scope, 'productChangeListCtrl', {unselectRows: selectedItems});
            ToastService.openStandardToast(data.trns.saveSuccess);
        })
    };

    this.deleteProducts = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/product/delete").then(function (data) {
            ListHelperService.refreshListData($scope, 'productChangeListCtrl', {unselectRows: selectedItems});
            ToastService.openStandardToast(data.trns.saveSuccess);
        })
    };

    this.copyProduct = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {proId: selectedListItems.getFirstSelectedId()}, "/product/copy").then(function (data) {
            ListHelperService.refreshListData($scope, 'productChangeListCtrl', {unselectRows: selectedItems});
            ToastService.openStandardToast(data.trns.saveSuccess);
        })
    };

    this.exportQRCodes = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        DownloadService.openDownloadPost('/product/qrcode/exportQRCodes', {paramName: "ids", paramValue: selectedListItems.getSelectedIds()});
        ListHelperService.refreshListData($scope, 'productChangeListCtrl', {unselectRows: selectedItems});
    }

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getViewLink, type:'link', condition:  ctrl.canView, process: 'ProductChange'},
        {label: "edit", linkFunction: ctrl.getEditLink, type:'link', condition:  ctrl.canEdit, process: 'ProductChange'},
        {label: "addOrderStop", action: ctrl.addOrderStop, condition: selectedListItems.isMultiSelection, process: 'ProductChange'},
        {label: "removeOrderStop", action: ctrl.removeOrderStop, condition:  selectedListItems.isMultiSelection, process: 'ProductChange'},
        {label: "pricerules", action: ctrl.openEditPriceRule, condition: ctrl.canEdit, process: 'ProductChange'},
        {label: "pricerules", action: ctrl.openEditPriceRule, condition: ctrl.canEditMultiple, process: 'ProductChange'},
        {label: "delete", action: ctrl.deleteProducts, condition:  selectedListItems.isMultiSelection, process: 'ProductChange'},
        {label: "copy", action: ctrl.copyProduct, condition:  selectedListItems.isSingleSelection, process: 'ProductChange'},
        {label: "exportQRCode", action: ctrl.exportQRCodes, condition:  selectedListItems.isMultiSelection, process: 'ProductChange'}
    ];

    this.meta = {
        rowTemplate: 'modules/product/templates/productchangelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/product/changelist',
        id: 'productchangelist',
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}